import gql from 'graphql-tag';

const departamentosTableQuery = gql`
    query departamentos($whereCondition:DepartamentosWhereWhereConditions, $numberItems: Int!, $numberPage: Int!, $fieldOrder: String!,$Order: SortOrder!) {
        departamentos(where:$whereCondition, first: $numberItems, page: $numberPage, activo: true, orderBy:[{field: $fieldOrder, order: $Order}]) {
            data{
                id,
                nombre,
                encargado,
                correo,
                descripcion,
                cliente_id
                empresa_id
                empresa{
                    nombre
                }
                sucursal_id
                sucursal{
                  nombre
                }
            }
            paginatorInfo {
                count
                currentPage
                firstItem
                lastItem
                hasMorePages
                lastPage
                perPage
                total
            }
        }
    }
`

const queries = { departamentosTableQuery };

export default queries;